import * as React from 'react';

import Tab, { Tabs } from '@/components/elements/Button/TabButton';
import { RaceType } from '@/pages/Top/types';

interface RaceTypeSelectorProps {
  raceType: RaceType;
  setRaceType: React.Dispatch<React.SetStateAction<RaceType>>;
}

const RaceTypeSelector: React.FC<RaceTypeSelectorProps> = ({
  raceType,
  setRaceType,
}) => {
  return (
    <Tabs>
      <Tab
        active={raceType === RaceType.Singlerace}
        onClick={() => setRaceType(RaceType.Singlerace)}
      >
        競輪投票
      </Tab>
      <Tab
        active={raceType === RaceType.Multirace}
        onClick={() => setRaceType(RaceType.Multirace)}
      >
        チャリロト・Dokanto!
      </Tab>
    </Tabs>
  );
};

export default RaceTypeSelector;
